import React, { useState, useRef, useEffect } from "react";
import { Editor } from '@tinymce/tinymce-react';
import "../../website/feedTypes/feedComponents/uploadFeed.scss";
import {
  createFeed,
  fileUpload,
  fileUploadAfterSignURL,
  generateMultipleSignUrl,
  teacherUploadHomeWork,
  teacherUploadFeedMultiple,
} from "../../../actions/emActions";
import Dropzone from "react-dropzone";
import { Progress, Spinner } from "reactstrap";
import { connect } from "react-redux";
import Select from "react-select";

const CreateFeedTutor = (props) => {
  const { programs } = props;
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [text, setText] = useState("");
  const [imageId, setimageId] = useState("");
  const [feedType, setfeedType] = useState();
  const [teacherId, setteacherId] = useState("");
  const [studentIds, setstudentIds] = useState([]);
  const [programInfo, setprogramInfo] = useState("");
  const [worksheetFileData, setworksheetFileData] = useState("");
  const [uploadLoading, setuploadLoading] = useState(false);
  const [programNameState, setprogramNameState] = useState({});
  const [showUpload, setShowUpload] = useState(false);
  const [tutorDataCheck, setTutorDataCheck] = useState("");
  const [programsData, setProgramsData] = useState([]);
  const [students, setstudents] = useState({});
  const [selectedStudents, setselectedStudents] = useState([]);
  const [tutorImage, settutorImage] = useState("");
  const [menuOpen, setmenuOpen] = useState(false);
  const [uploadPercentage, setUploadPercentage] = useState(0);

  const fileInputRef = useRef(null);

  if (props.tutorData !== tutorDataCheck) {
    const programs = props.tutorData?.progs?.map((item) => {
      return {
        value: item?.prog_name,
        label: item?.prog_name,
        ...item,
      };
    });

    setTutorDataCheck(props.tutorData);
    setProgramsData(programs);
    setstudents(props.tutorData?.teacher_students);
    settutorImage(props?.tutorData?.user?.image);
    setteacherId(props?.tutorData?.user?.user_id);
  }
  console.log("Programs Data", programsData);
  console.log("students Data", students);

  // if (props.programNameState.programName !== programNameState) {
  //   const { programNameState } = props;
  //   console.log("Program Info", programNameState);
  //   setprogramNameState(programNameState.programName);
  //   setprogramInfo(programNameState);

  //   var tutorData = JSON.parse(localStorage.getItem("loginData"));
  //   if (tutorData && programNameState) {
  //     setteacherId(tutorData.user.user_id);

  //     //To Get Students Logic
  //     let TeacherStudent = tutorData.teacher_students;

  //     if (TeacherStudent[programNameState.programName]) {
  //       var studentId = TeacherStudent[programNameState.programName].map(
  //         (item) => item.student_id
  //       );

  //       setstudentIds(studentId.join(","));
  //     }
  //   }
  // }

  const handleFileChange = (acceptedFiles) => {
    debugger;
    const newSelectedFiles = [...selectedFiles, ...acceptedFiles];
    setSelectedFiles(newSelectedFiles);

    const newPreviews = acceptedFiles.map((file, index) => ({
      id: index,
      file,
      preview: URL.createObjectURL(file),
      isImage: file.type.startsWith("image/"),
      isVideo: file.type.startsWith("video/"),
    }));
    setPreviews([...previews, ...newPreviews]);
  };

  const handleChooseFile = () => {
    fileInputRef.current.click();
  };

  console.log("Student Ids", studentIds);
  console.log("programInfo", programInfo);
  console.log("Selected Files", selectedFiles);

  const uploadFeedFunc = () => {
    setuploadLoading(true);
    if (selectedFiles.length > 0) {
      const items = selectedFiles.map((item) => {
        return {
          filename: item?.name,
          fileUserType: "tutor",
          contentType: item?.type,
          label: "Feeds/tutor",
          userId: teacherId.toString(),
        };
      });

      let feedData = [];

      generateMultipleSignUrl(items)
        .then((res) => {
          debugger;
          if (res?.status === 201) {
            const uploadPromises = res?.data?.map((item, index) => {
              return fileUploadAfterSignURL(
                item?.signurl,
                selectedFiles[index],
                (progressEvent) => {
                  const { loaded, total } = progressEvent;
                  const percentCompleted = Math.floor((loaded * 100) / total);
                  setUploadPercentage(percentCompleted);
                }
              );
            });

            feedData = res?.data.map((item) => {
              return {
                message: text,
                url: item.url,
                url_type: item.filetype,
              };
            });

            // Wait for all uploads to complete
            return Promise.all(uploadPromises);
          }
        })
        .then((uploadResults) => {
          debugger;
          // Check if all uploads were successful
          const allUploadsSuccessful = uploadResults.every(
            (result) => result.status === 200
          );
          debugger;
          if (allUploadsSuccessful) {
            debugger;
            teacherUploadFeedMultiple(
              "0",
              0,
              programInfo?.course_id,
              programInfo?.prog_id,
              teacherId,
              programInfo?.slot_id,
              "teacher_upload_multiple",
              studentIds
                .map((item) => {
                  return item?.value;
                })
                .join(","),
              feedData
            ).then((res) => {
              debugger;
              window.location.reload();
              setuploadLoading(false);
            });
          } else {
            // Handle the case where not all files were uploaded successfully
            console.log("Some files failed to upload.");
            window.alert("Some files failed to upload.");
          }
        })
        .catch((error) => {
          // Handle any errors that occurred during the process
          console.error("Error during file upload:", error);
          window.alert("Error during file upload:");
        })
        .finally(() => {
          setuploadLoading(false);
        });
    } else {
      const feedData = [
        {
          message: text,
          url: "",
          url_type: "text",
        },
      ];
      teacherUploadFeedMultiple(
        "0",
        0,
        programInfo?.course_id,
        programInfo?.prog_id,
        teacherId,
        programInfo?.slot_id,
        "teacher_message_text",
        studentIds
          .map((item) => {
            return item?.value;
          })
          .join(","),
        feedData
      ).then((res) => {
        debugger;
        window.location.reload();
        setuploadLoading(false);
      });
    }
  };
  const handleEditorChange = (content) => {
    setText(content);
    console.log("Editor content:", content); // Log the editor content
  };

  useEffect(() => {
    if (students) {
      debugger;
      const selectedStudents = students[programInfo?.value]?.map((item) => {
        return {
          value: item?.student_id,
          label: item?.user_name,
          image: item?.image,
        };
      });
      setselectedStudents(selectedStudents);
    }
  }, [programInfo]);
  // remove selected image from images
  const handleRemoveImg = (index) => {
    const updatedSelectedFiles = [...selectedFiles];
    updatedSelectedFiles.splice(index, 1);

    const updatedPreviews = [...previews];
    updatedPreviews.splice(index, 1);

    setSelectedFiles(updatedSelectedFiles);
    setPreviews(updatedPreviews);
  };

  const selectAllFunc = (e) => {
    if (e.target.checked) {
      setstudentIds(selectedStudents);
    } else {
      setstudentIds([]);
    }
  };

  return (
    <div className="card text-left uploadFeed">
      <div className="card-body">
        <div className="d-flex">
          {tutorImage !== "null" ? (
            <img
              src={`https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/${tutorImage}`}
              alt="Avatar"
              className="avatarStudent"
            />
          ) : (
            <img
              src={require("../../../public/images/emptyuserphoto.png")}
              alt="Avatar"
              className="avatarStudent"
            />
          )}
          <label className="card-title mb-0 my-auto ml-2">
            Share Information with your students
          </label>
        </div>
        <form className="mt-3 row">
        <div className="col-md-12 mt-3">
         
         <Editor
            apiKey="mppsbn7j0cbtjdkpsffzcdbv6sk6ynge8701axyxfm27bspa"
                initialValue={' '}
                init={{
                height: 200,
                menubar: false,
                plugins: [
                'advlist autolink lists link image charmap print preview anchor',
                'searchreplace visualblocks code fullscreen',
                'insertdatetime media table paste code help wordcount',
                'lists'
                        ],
                toolbar:
                'undo redo | formatselect | bold italic | \
                 alignleft aligncenter alignright alignjustify | \
                 bullist numlist outdent indent | removeformat | help',
                 content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                 placeholder: 'Add caption here'
                }}
            onEditorChange={handleEditorChange}
          />
           <div className="mt-4" onClick={() => setShowUpload(!showUpload)}>
              <i
                className="fa fa-file-image-o"
                aria-hidden="true"
                style={{
                  fontSize: 22,
                  color: "green",
                  cursor: "pointer",
                }}
              ></i>
              <label
                className="ml-2 text-muted text-sm"
                style={{ fontSize: 14, cursor: "pointer" }}
              >
                {showUpload ? "Close" : "Add Images/Videos"}
              </label>
            </div>
          
        </div>
          {showUpload && (
            <>
              <div className="col-md-12">
                <Dropzone
                  accept="image/*, video/*"
                  maxFiles={2}
                  onDrop={(acceptedFiles) => handleFileChange(acceptedFiles)}
                >
                  {({ getRootProps, getInputProps }) => (
                    <div {...getRootProps({ className: "dropzone" })}>
                      <input {...getInputProps()} />
                      <p>Drag 'n' drop images/video here, or click to select</p>
                    </div>
                  )}
                </Dropzone>
              </div>

              {selectedFiles.length > 0 && (
                <>
                  <div className="col-md-8">
                    <div className="p-2">
                      {programs?.map((item) => (
                        <div>
                          <input
                            type="radio"
                            onClick={(e) => {
                              setstudentIds([]);
                              setprogramInfo(e.target.value);
                            }}
                            value={JSON.stringify(item)}
                            checked={
                              programInfo &&
                              JSON.parse(programInfo)?.progid === item?.progid
                            }
                          />
                          <label className="ml-2">{item?.prog_name}</label>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="col-md-12 mt-2">
                    <div className="row">
                      {previews.map((preview, index) => (
                        <div className="col-md-4" key={index}>
                          {preview.isImage ? (
                            <div>
                              <img
                                className="uploadedImg"
                                src={preview.preview}
                                alt={`Preview ${index}`}
                                // style={{ width: "100%", height: "auto" }}
                              />
                              <i
                                onClick={() => handleRemoveImg(index)}
                                className="fa fa-times closeIcon"
                              />
                            </div>
                          ) : preview.isVideo ? (
                            <div>
                              <video controls width={134} height={134}>
                                <source
                                  src={preview.preview}
                                  type={preview.file.type}
                                />
                                Your browser does not support the video tag.
                              </video>
                              <i className="fa fa-times closeIcon" />
                            </div>
                          ) : (
                            <p>Unsupported file type</p>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              )}
            </>
          )}
          <div className="col-md-6 mt-3">
            <label>In which course?</label>
            <Select options={programsData} onChange={setprogramInfo} />
          </div>
          <div className="col-md-6 mt-3">
            <div className="d-flex justify-content-between">
              <label>Send to which students?</label>
              {programInfo && (
                <label className="text-muted">
                  Select All:{" "}
                  <input onChange={(e) => selectAllFunc(e)} type="checkbox" />
                </label>
              )}
            </div>
            <Select
              isMulti
              options={selectedStudents}
              value={studentIds}
              onChange={setstudentIds}
              formatOptionLabel={(item) => (
                <div>
                  {item.image !== null ? (
                    <img
                      src={`https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/${item.image}`}
                      alt="Avatar"
                      className="avatarStudentSmall"
                    />
                  ) : (
                    <img
                      src={require("../../../public/images/empty.svg")}
                      alt="Avatar"
                      className="avatarStudentSmall"
                    />
                  )}
                  <span className="ml-2">{item.label}</span>
                </div>
              )}
            />
          </div>

          <div className="col-md-12 d-flex justify-content-between text-right mt-3">
            <div className="row">
              {/* <div className="col-md-12">
                    <Select options={options} />
                  </div> */}
            </div>
            <div>
              <button
                // type="submit"
                style={{cursor:'pointer'}}
                disabled={
                  (selectedFiles?.length > 0 || text) &&
                  programInfo &&
                  studentIds?.length > 0 &&
                  !uploadLoading
                    ? false
                    : true
                }
                className="uploadBtn"
                onClick={() => uploadFeedFunc()}
              >
                {uploadLoading ?<Spinner size="sm" />: "Post"}
              </button>
            </div>
          </div>
          <div className="col-md-12 d-flex justify-content-between text-right mt-3">
              {
                uploadLoading ? <Progress animated bar color="success" className="my-2" value={uploadPercentage}> 
                {uploadPercentage}%
              </Progress> : ''
              }
          </div>
          {/* <div className="col-md-12 mt-3">
              <button type="button" className="chooseFileBtn" onClick={handleChooseFile}>
              Choose Image or Video
              </button>
              </div>
              <div className="form-group">
              <input
              type="file"
              className="form-control-file d-none"
              id="fileInput"
              accept="image/*, video/*"
              onChange={handleFileChange}
              ref={fileInputRef}
              />
            </div> */}
        </form>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    programNameState: state.feedTutorRed.programName,
    tutorData: state.feedTutorRed.tutorData,
  };
}
export default connect(mapStateToProps, null)(CreateFeedTutor);
